import { useDynamicEntityCMSDataContext, useDynamicEntityStoreContext } from '../contexts';
import { COMPONENT_IDENTIFIER_KEYWORD } from '../lib';

import PropField from './_component_settings/PropField';
import TemplateMapper from './TemplateMapper';

export default function PropertySettingsPane() {
  const { componentDefinitions, isTemplate } = useDynamicEntityCMSDataContext();

  const content = useDynamicEntityStoreContext((state) => state.data.content);
  const componentBeingEditedIndex = useDynamicEntityStoreContext((state) => state.componentBeingEditedIndex);
  const elementBeingEditedName = useDynamicEntityStoreContext((state) => state.elementBeingEditedName);
  const updateIndividualContent = useDynamicEntityStoreContext((state) => state.updateIndividualContent);

  const component = content[componentBeingEditedIndex] || null;

  const definition = componentDefinitions.find((c) => {
    const componentIdentifier = c[COMPONENT_IDENTIFIER_KEYWORD];
    const currentComponentIdentifier = component?.[COMPONENT_IDENTIFIER_KEYWORD];

    return componentIdentifier !== undefined && currentComponentIdentifier !== undefined && componentIdentifier === currentComponentIdentifier;
  });

  const propSchema = definition?.propSchema.find((prop) => prop.name === elementBeingEditedName);
  const propsGroupedUnderElementBeingEdited = definition?.propSchema.filter((prop) => prop.grouped_under === elementBeingEditedName) || [];
  const type = propSchema.type;

  const handleChange = (newValue) => updateIndividualContent(component.id, ['props', elementBeingEditedName], newValue);

  const value = component.props[elementBeingEditedName];

  return (
    <div className="d-flex flex-column pb-4 px-2 h-100 overflow-auto">
      <div className="d-flex flex-column gap-1 mb-3">
        <h3 className="mb-1 w-100 d-inline-block text-truncate">Settings for {definition[COMPONENT_IDENTIFIER_KEYWORD] || 'Component'}</h3>
      </div>
      <div className="d-flex flex-column gap-3">
        <div className="d-flex flex-column gap-2">
          <ul>
            <li>Element Name: {elementBeingEditedName}</li>
            <li>Type: {type}</li>
          </ul>
        </div>
        {isTemplate && <TemplateMapper {...{ handleChange, value }} />}

        {!isTemplate && !propsGroupedUnderElementBeingEdited.length && (
          <div className="d-flex flex-column align-items-center justify-content-center text-muted h-100">
            <span>No settings are available.</span>
          </div>
        )}
      </div>
      {propsGroupedUnderElementBeingEdited.length > 0 && (
        <div className="d-flex flex-wrap px-2">
          {propsGroupedUnderElementBeingEdited.map((prop, index) => (
            <PropField key={index} {...{ component, ...prop }} />
          ))}
        </div>
      )}
    </div>
  );
}
